import { useNavigate } from 'react-router-dom';
import { LessonSubjectsTable } from '../../../../components/Lessons/Tables/Subjects/LessonSubjectsTable';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const DeputateEvaluatePlannedSubjectsSubpage = () => {
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  function handleNavigate(subjectUuid: string) {
    navigate(subjectUuid);
  }

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <LessonSubjectsTable isEvaluation onNavigate={handleNavigate} />
    </Page>
  );
};
